export default function VdClickSelectDirective() {
  'ngInject'
  return {
    restrict: 'A',
    link(scope, $element) {
      const elementNode = $element[0]
      let hasSelected = false

      elementNode.addEventListener('click', () => {
        // When the input has been initially clicked inside, highlight the text.
        // Until focus is lost from the input, don't re-select all of the text.
        if (!hasSelected) {
          elementNode.setSelectionRange(0, elementNode.value.length)
          hasSelected = true
        }
      })

      elementNode.addEventListener('blur', () => {
        hasSelected = false
      })
    },
  }
}
